"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('./interfaces'),
    SamplePaperProduct = _require.SamplePaperProduct;

var type = require('./constants').CUSTOM_SAMPLES;

var _require2 = require('../components'),
    InvitationEnvelope = _require2.InvitationEnvelope,
    ResponseCardEnvelope = _require2.ResponseCardEnvelope,
    Invitation = _require2.Invitation,
    LargeEnclosure = _require2.LargeEnclosure,
    LetterpressInvitation = _require2.LetterpressInvitation,
    LetterpressLargeEnclosure = _require2.LetterpressLargeEnclosure,
    LetterpressResponseCard = _require2.LetterpressResponseCard,
    LetterpressSmallEnclosure = _require2.LetterpressSmallEnclosure,
    ResponseCard = _require2.ResponseCard,
    SmallEnclosure = _require2.SmallEnclosure,
    VellumJacket = _require2.VellumJacket,
    WaxSeal = _require2.WaxSeal,
    MediumWrapper = _require2.MediumWrapper,
    EnvelopeLiner = _require2.EnvelopeLiner,
    EuroFlapEnvelopeLiner = _require2.EuroFlapEnvelopeLiner;

var NONE = 'None';
var RIBBON = 'Ribbon';
var BELLY_BAND = 'Belly Band';
var VELLUM_AND_WAX_SEALS = 'Vellum, Wax Seals';
var BELLY_BAND_WITH_VELLUM_AND_WAX_SEALS = 'Belly Band, Vellum, Wax Seals';

var CustomSamples = /*#__PURE__*/function (_SamplePaperProduct) {
  _inherits(CustomSamples, _SamplePaperProduct);

  var _super = _createSuper(CustomSamples);

  function CustomSamples() {
    var _this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CustomSamples);

    _this = _super.call(this, params);
    _this.product_type = type;
    _this.design_name = params.design_name || 'Natalie';
    _this.paper_type = params.paper_type || 'White Matte';
    _this.printing_type = params.printing_type || 'flat';
    _this.bundle_style = params.bundle_style || 'None';
    _this.ribbon_color = params.ribbon_color || 'None';
    _this.wax_seal_style = params.wax_seal_style || 'Silver Florette';
    _this.has_liner = params.has_liner === undefined ? true : params.has_liner;
    _this.liner_color = params.liner_color || 'Dusty Blue';
    _this.liner_pattern = params.liner_pattern || 'Hydrangea';

    if (_this.liner_pattern === 'None') {
      _this.has_liner = false;
    }

    _this.ink_color = params.ink_color || 'Black';
    _this.accent_color = params.accent_color || 'Black';
    _this.border_color_a = params.border_color_a || 'Black';
    _this.border_color_b = params.border_color_b || 'Black';
    _this.wrapper_color = params.wrapper_color || 'Dusty Blue';
    _this.wrapper_personalization = params.wrapper_personalization || false;
    _this.envelope_color = params.envelope_color || 'Paper';
    _this.envelope_ink_color = params.envelope_ink_color || 'Black';
    _this.price_calculator_version = params.price_calculator_version;
    _this.custom_classic_sample_table_version = params.custom_classic_sample_table_version;
    _this.custom_letterpress_sample_table_version = params.custom_letterpress_sample_table_version;

    if (_this.bundle_style === RIBBON && _this.ribbon_color === NONE) {
      _this.ribbon_color = 'Heather';
    } else if (_this.bundle_style === NONE && _this.ribbon_color !== NONE) {
      _this.ribbon_color = NONE;
    }

    if (_this.printing_type === 'letterpress') {
      _this.paper_type = 'White Cotton';
    }

    if (_this.printing_type === 'flat' && _this.paper_type === 'White Cotton') {
      _this.paper_type = 'White Matte';
    }

    return _this;
  } // eslint-disable-next-line class-methods-use-this


  _createClass(CustomSamples, [{
    key: "defaults",
    value: function defaults() {}
  }, {
    key: "styling",
    get: function get() {
      if (this.bundle_style === RIBBON) {
        return "".concat(this.ribbon_color, " Ribbon");
      }

      if (this.bundle_style === BELLY_BAND) {
        return this.wrapper_personalization ? "".concat(this.wrapper_color, " Personalized Belly Band") : "".concat(this.wrapper_color, " Belly Band");
      }

      if (this.bundle_style === VELLUM_AND_WAX_SEALS) {
        return "Vellum & ".concat(this.wax_seal_style, " Wax Seals");
      }

      if (this.bundle_style === BELLY_BAND_WITH_VELLUM_AND_WAX_SEALS) {
        return [this.wrapper_personalization ? "".concat(this.wrapper_color, " Personalized Belly Band") : "".concat(this.wrapper_color, " Belly Band"), "Vellum & ".concat(this.wax_seal_style, " Wax Seals")].join(' + ');
      }

      return 'None';
    }
  }, {
    key: "liner_style",
    get: function get() {
      if (!this.has_liner) {
        return 'None';
      }

      if (this.liner_pattern === 'None') {
        return 'None';
      }

      if (['Emma', 'Audrey', 'Grace', 'Victoria', 'Marguerite', 'Josephine', 'Anastasia', 'Clara', 'Lilah', 'Juliette', 'Scarlett', 'Rose'].includes(this.liner_pattern)) {
        return this.liner_pattern;
      }

      return "".concat(this.liner_color, " ").concat(this.liner_pattern);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "requires_custom_postage",
    get: function get() {
      return false;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "requires_guest_addressing",
    get: function get() {
      return false;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "requires_name_printing",
    get: function get() {
      return false;
    }
  }, {
    key: "components",
    get: function get() {
      var arr = [];

      if (this.printing_type === 'letterpress') {
        arr.push(new LetterpressInvitation({
          quantity: 1,
          paper_type: this.paper_type,
          acc_ribbon: this.ribbon_color
        }));
        arr.push(new LetterpressResponseCard({
          quantity: 1,
          paper_type: this.paper_type
        }));
        arr.push(new LetterpressSmallEnclosure({
          quantity: 1,
          paper_type: this.paper_type
        }));
        arr.push(new LetterpressLargeEnclosure({
          quantity: 1,
          paper_type: this.paper_type
        }));
      } else {
        arr.push(new Invitation({
          quantity: 1,
          paper_type: this.paper_type,
          acc_ribbon: this.ribbon_color
        }));
        arr.push(new ResponseCard({
          quantity: 1,
          paper_type: this.paper_type
        }));
        arr.push(new SmallEnclosure({
          quantity: 1,
          paper_type: this.paper_type
        }));
        arr.push(new LargeEnclosure({
          quantity: 1,
          paper_type: this.paper_type
        }));
      }

      arr.push(new InvitationEnvelope({
        quantity: 1,
        double_envelopes: this.envelope_color === 'Paper',
        guest_addressing: this.envelope_color === 'Paper',
        name_printing: this.envelope_color === 'Paper',
        return_addressing: this.envelope_color === 'Paper',
        paper_type: this.paper_type,
        envelope_color: this.envelope_color,
        envelope_ink_color: this.envelope_ink_color
      }));

      if (this.has_liner) {
        if (this.envelope_color === 'Paper') {
          arr.push(new EnvelopeLiner({
            quantity: 1,
            paper_type: this.paper_type,
            liner_color: this.liner_color,
            liner_pattern: this.liner_pattern
          }));
        } else {
          arr.push(new EuroFlapEnvelopeLiner({
            quantity: 1,
            paper_type: this.paper_type,
            liner_color: this.liner_color,
            liner_pattern: this.liner_pattern
          }));
        }
      }

      arr.push(new ResponseCardEnvelope({
        quantity: 1,
        paper_type: this.paper_type,
        return_addressing: this.envelope_color === 'Paper',
        envelope_color: this.envelope_color,
        envelope_ink_color: this.envelope_ink_color
      }));

      switch (this.bundle_style) {
        case NONE:
          if (this.ribbon_color !== NONE) {
            console.error('Ribbon color is not None, but bundle style is None');
          }

          break;

        case RIBBON:
          if (this.ribbon_color === NONE) {
            console.error('Ribbon color is None, but bundle style is Ribbon');
          }

          break;

        case VELLUM_AND_WAX_SEALS:
          arr.push(new VellumJacket({
            quantity: 1
          }));
          arr.push(new WaxSeal({
            quantity: 1,
            wax_seal_style: this.wax_seal_style
          }));
          break;

        case BELLY_BAND_WITH_VELLUM_AND_WAX_SEALS:
          arr.push(new VellumJacket({
            quantity: 1
          }));
          arr.push(new WaxSeal({
            quantity: 1,
            wax_seal_style: this.wax_seal_style
          }));
          arr.push(new MediumWrapper({
            quantity: 1,
            paper_type: this.paper_type === 'White Shimmer' ? 'White Shimmer' : 'White Matte',
            wrapper_color: this.wrapper_color,
            personalized: this.wrapper_personalization
          }));
          break;

        case BELLY_BAND:
          arr.push(new MediumWrapper({
            quantity: 1,
            paper_type: this.paper_type === 'White Shimmer' ? 'White Shimmer' : 'White Matte',
            wrapper_color: this.wrapper_color,
            personalized: this.wrapper_personalization
          }));
          break;

        default:
      }

      return arr;
    }
  }, {
    key: "subcomponents",
    value: function subcomponents() {
      var arr = [];
      this.components.forEach(function (component) {
        var subcomponent_array = component.subcomponents;

        if (Array.isArray(subcomponent_array)) {
          arr.push.apply(arr, _toConsumableArray(subcomponent_array));
        } else {
          arr.push(subcomponent_array);
        }
      });
      return arr;
    } // eslint-disable-next-line class-methods-use-this, no-empty-function

  }, {
    key: "ink_colors",
    get: function get() {
      if (this.printing_type === 'letterpress') {
        return ['Soft Black'];
      }

      if (this.design_name === 'Sophisticated Modern') {
        return ["".concat(this.ink_color, " Text"), "".concat(this.accent_color, " Accent"), "".concat(this.border_color_a, " Border")];
      }

      if (this.design_name === 'Upscale Monogram') {
        return ["".concat(this.ink_color, " Text"), "".concat(this.accent_color, " Accent"), "".concat(this.border_color_a, " & ").concat(this.border_color_b, " Borders")];
      }

      if (['Bethany', 'Emma', 'Florence', 'Glam Monogram', 'Grace', 'Katherine', 'Mackenzie', 'Modern Glamour', 'Simply Classic'].includes(this.design_name)) {
        return [this.ink_color, this.border_color_a];
      }

      return [this.ink_color];
    },
    set: function set(arr) {}
  }]);

  return CustomSamples;
}(SamplePaperProduct);

CustomSamples.prototype.constructors = {};
module.exports = CustomSamples;